// Generates a URL-safe slug from any title/name — used to build the
// #project-<slug> hash link and resolve it back to a project, and reused
// wherever else a record needs a stable, derived (not stored) slug, such as
// a mobile app's /mobileapps/<slug>/privacypolicy URL.
export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

// Back-compat alias for the project-specific call sites.
export const generateProjectSlug = generateSlug;
